import { render, staticRenderFns } from "./vueSelecto.vue?vue&type=template&id=e4332a1c&"
import script from "./vueSelecto.vue?vue&type=script&lang=js&"
export * from "./vueSelecto.vue?vue&type=script&lang=js&"
import style0 from "./vueSelecto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports